/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Skill, Skill$inboundSchema } from "./skill.js";

/**
 * A page of active project skills.
 */
export type ListSkillsResult = {
  /**
   * Cursor for the next page; absent when exhausted.
   */
  nextCursor?: string | undefined;
  /**
   * The active skills in this page.
   */
  skills: Array<Skill>;
  /**
   * The total number of active skills matching the filters.
   */
  totalCount: number;
};

/** @internal */
export const ListSkillsResult$inboundSchema: z.ZodMiniType<
  ListSkillsResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    skills: z.array(Skill$inboundSchema),
    total_count: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
      "total_count": "totalCount",
    });
  }),
);

export function listSkillsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSkillsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSkillsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSkillsResult' from JSON`,
  );
}
